import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {LoginPage} from '../login/login';
import {PasswordRecoveryPage} from '../password-recovery/password-recovery';
import {WelcomePage} from '../welcome/welcome';
import {TabsControllerPage} from "../tabs-controller/tabs-controller";

@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html'
})
export class SignupPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }

  goToMyInfo(params) {
    if (!params) params = {};
    this.navCtrl.setRoot(TabsControllerPage);
  }

  goToLogin(params) {
    if (!params) params = {};
    this.navCtrl.setRoot(WelcomePage);
    this.navCtrl.push(LoginPage);
  }

  goToPasswordRecovery(params) {
    if (!params) params = {};
    this.navCtrl.push(PasswordRecoveryPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts